export const ResponseHeader = (
  r: Request | Response | XMLHttpRequest,
  header: string,
  s: string = ""
): string =>
  ("headers" in r ? r.headers.get(header) : r.getResponseHeader(header)) || s
